import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./index.css";

// PWA：注册 Service Worker（离线 + 可安装）。生产构建生效；更新失败回退存量 SW，不删除本地数据。
registerSW({ immediate: true, onOfflineReady() {
  console.info("PWA 已可离线使用");
} });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
